module.exports = __webpack_public_path__ + "img/negative-form.e3d223cd.svg";